import styled from 'styled-components'

export const HomeCard = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 70px;
  margin-left: 270px;
  background-color: ${props => (props.theme === true ? '#181818' : '#f9f9f9')};
  @media screen and (max-width: 767px) {
    margin-left: 0px;
  }
`
export const BannerContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 280px;
  background-image: url('https://assets.ccbp.in/frontend/react-js/nxt-watch-banner-bg.png');
  background-size: cover;
  padding: 28px;
  @media screen and (max-width: 576px) {
    height: 200px;
    padding: 15px;
  }
`

export const BannerHeaderContainer = styled.nav`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;
`

export const WebLogo = styled.img`
  height: 43px;
  width: 110px;
  @media screen and (max-width: 576px) {
    height: 24px;
    width: 80px;
  }
`
export const BannerButtonIcon = styled.button`
  outline: none;
  cursor: pointer;
  height: 20px;
  width: 20px;
  color: #231f20;
  border: none;
  background: transparent;
`
export const BannerMatter = styled.p`
  font-family: 'Roboto';
  font-weight: 500;
  font-size: 20px;
  line-height: 1.1;
  color: #606060;
  width: 45%;
  @media screen and (max-width: 576px) {
    font-size: 14px;
  }
`

export const BannerButton = styled.button`
  width: 125px;
  height: 40px;
  padding: 3px;
  margin-bottom: 10px;
  margin-top: 20px;
  outline: none;
  cursor: pointer;
  border: 1px solid #383838;
  color: #383838;
  font-family: 'Roboto';
  font-size: 14px;
  font-weight: 800;
  border-radius: 4px;
  background: transparent;
  @media screen and (max-width: 576px) {
    width: 80px;
    height: 25px;
    font-size: 10px;
  }
`

export const HomeVideosContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 30px;
  background: transparent;
  @media screen and (max-width: 576px) {
    padding: 16px;
  }
`
export const HomeInputContainer = styled.div`
  height: 40px;
  max-width: 600px;
  display: flex;
  flex-direction: row;
  border: 1px solid;
  border-color: ${props => (props.theme === true ? '#909090' : '#cccccc')};
  @media screen and (max-width: 576px) {
    max-width: 100%;
    height: 28px;
  }
`

export const HomeInputEl = styled.input`
  height: 100%;
  width: 85%;
  border: none;
  border-right: 1px solid;
  border-color: ${props => (props.theme === true ? '#909090' : '#cccccc')};
  font-family: 'Roboto';
  font-size: 18px;
  color: ${props => (props.theme === true ? '#f4f4f4' : '#cccccc')};
  padding: 8px;
  background-color: ${props => (props.theme === true ? '#181818' : '#ffffff')};
  @media screen and (max-width: 576px) {
    font-size: 11px;
  }
`
export const HomeSearchButton = styled.button`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  outline: none;
  cursor: pointer;
  height: 100%;
  width: 15%;
  text-align: center;
  font-size: 25px;
  border: none;
  color: ${props => (props === true ? '#909090' : '#606060')};
  background-color: ${props => (props.theme === true ? '#424242' : '#cbd5e1')};
  @media screen and (max-width: 576px) {
    font-size: 12px;
  }
`

export const HomePageVideosList = styled.ul`
  display: flex;
  flex-direction: row;
  margin-top: 25px;
  list-style-type: none;
  flex-wrap: wrap;
  @media screen and (max-width: 576px) {
    margin-top: 15px;
    padding: 0px;
  }
`
export const HomeVideoItemCard = styled.li`
    text-decoration:none;
    list-style:none;
    width:320px;
    height:450px
    border:none;
    margin:17px;
    margin-left:0px;
    background:transparent;
    @media screen and  (max-width: 576px){
        margin:0px;
        width:95%;
    }
    @media screen and  (min-width: 577px) and (max-width:767px){
        width:44%;
        max-width:300px;
    } 
`
export const HomeThumbnailUrl = styled.img`
  height: 47%;
  width: 100%;
  margin-bottom: 12px;
`
export const HomeVideoItemBottomContainer = styled.div`
  display: flex;
  justify-content: space-between;
`
export const HomeChannelLogo = styled.img`
  height: 50px;
  width: 30px;
  margin-right: 9px;
`
export const HomeVideoItemTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const HomeVideoItemTitle = styled.p`
  font-family: 'Roboto';
  font-size: 15px;
  font-weight: 500;
  line-height: 1.3;
  margin-bottom: 5px;
  color: ${props => (props.theme === true ? '#f4f4f4' : '#313131')};
`
export const HomeVideoItemChannelName = styled.p`
  font-family: 'Roboto';
  font-size: 13px;
  color: ${props => (props.theme === true ? '#7e858e' : '#606060')};
  margin-bottom: 10px;
`
export const HomeViewAndYearItems = styled.ul`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  padding: 0px;
`
export const HomeYear = styled.p`
  font-family: 'Roboto';
  font-size: 11px;
  color: ${props => (props.theme === true ? '#7e858e' : '#606060')};
`

export const HomeViews = styled(HomeYear)`
  list-style: none;
  margin-right: 11px;
`
export const HomeNoResultsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
`

export const HomeNoResultsImg = styled.img`
  height: 200px;
  width: 200px;
  margin-bottom: 10px;
`

export const HomeNoResultsHeading = styled.h1`
  font-size: 40px;
  text-align: center;
  margin-bottom: 10px;
  font-family: 'Roboto';
  font-weight: bold;
  color: ${props => (props.theme === true ? '#ffffff' : '#313131')};
`
export const HomeNoResultsPara = styled.p`
  font-size: 20px;
  text-align: center;
  margin-bottom: 10px;
  font-family: 'Roboto';
  color: ${props => (props.theme === true ? '#7e858e' : '#606060')};
`
export const HomeNoResultsButton = styled.button`
  height: 42px;
  width: 120px;
  color: #fffffff;
  background-color: #3b82f6;
  border: none;
  border-radius: 8px;
  text-align: center;
  outline: none;
  cursor: pointer;
`
